import React from "react";
import TypeUtils from "../../../utils/TypeUtils.js";
import PillList from "../../common/widgets/PillList.js";
import "./SkillMatchBlock.scss";
import useTranslationJobs from "../useTranslationJobs.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";

export default function SkillMatchBlock(props) {

  const {t, loading: tLoading} = useTranslationJobs();
  const {skills, matchFunction} = props;
  const hasSkills = TypeUtils.ensureArray(skills).length > 0;

  useShowLoader(tLoading, "SkillMatchBlock");

  // RENDER

  return (
    <div className="SkillMatchBlock spaced-children">
      {!hasSkills &&
      <span className="no-skills-label">{t("jobs:job_no_skill_label")}</span>
      }
      {hasSkills &&
      <PillList items={skills} variant="tertiary" altVariant="success"
                altTest={(item) => matchFunction(item)}/>
      }
    </div>
  );
}
